import React from 'react'

const NotAdvised  = () => {
  return (
    <div className="jumbotron">
      <h1>You are not advised for this semester.</h1>
    </div>
  )
}

export default NotAdvised



// WEBPACK FOOTER //
// ./src/containers/Enrolment/not-advised.js